<div class="tooltip">
  <ng-content select="[placeholder]"></ng-content>

  <div class="tooltip-content {{position}}">
      <ng-content select="[content]"></ng-content>
  </div>
</div>
